<div>
  <mat-form-field>
    <mat-label>{{ label }}</mat-label>
    <input
      matInput
      type="text"
      placeholder="{{ placeholder }}"
      #trigger="matAutocompleteTrigger"
      [formControl]="stringSearch"
      [matAutocomplete]="auto"
      data-testid="filter-input"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStrings">
      <mat-option
        *ngFor="let stringValue of filteredStrings | async; let i = index; trackBy: trackByIndex"
        [value]="stringSelection.selected"
      >
        <div (click)="selectString($event, stringValue, i); toggleAutocompletePanel(trigger)">
          <ng-template [ngIf]="multiple" [ngIfElse]="single">
            <mat-checkbox
              color="primary"
              (click)="$event.stopPropagation()"
              (change)="$event ? toggleString(stringValue, i) : null; toggleAutocompletePanel(trigger)"
              [checked]="stringSelectionToggles[i]"
              data-testid="filter-option"
            >
              {{ stringValue | uppercase }}
            </mat-checkbox>
          </ng-template>
          <ng-template #single>
            {{ stringValue | uppercase }}
          </ng-template>
        </div>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</div>
